import { useEffect, useState } from "react";

export default function useMediaQuery() {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		setIsMobile(window.matchMedia("(max-width: 1024px)").matches);
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.matchMedia("(max-width: 1024px)").matches);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return {
		isMobile,
	};
}
